import { brand, type Role, secondary, state } from '@alison/ui';

// FIXME: placeholder roles for the header. Replace with the real roles endpoint
// once it exists.

export const DEFAULT_ROLE: Role = {
  id: 'ua',
  name: 'UA Manager',
  full: 'User Acquisition',
  desc: 'Scaling, fatigue & spend efficiency',
  initials: 'UA',
  color: brand.blue,
};

export const ROLES: Role[] = [
  DEFAULT_ROLE,
  {
    id: 'creative',
    name: 'Creative Manager',
    full: 'Creative',
    desc: "Hooks, elements & what's resonating",
    initials: 'CM',
    color: brand.purple,
  },
  {
    id: 'cmo',
    name: 'CMO',
    full: 'Marketing',
    desc: 'Portfolio performance & brand',
    initials: 'CO',
    color: secondary.main,
  },
  {
    id: 'cfo',
    name: 'CFO',
    full: 'Finance',
    desc: 'Budget, efficiency & ROAS',
    initials: 'CF',
    color: state.success.main,
  },
];
